
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const MapSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-2 text-fabre-gray">
            NOS IMPLANTATIONS
          </h2>
          <div className="w-20 h-1 bg-fabre-green mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 mb-8">
            Découvrez nos centres répartis dans toute la France
          </p>
        </div>
        
        <div className="w-full h-[500px] rounded-lg shadow-lg border border-gray-200 mb-8">
          <iframe 
            src="https://storage.googleapis.com/maps-solutions-qcoqmdt5th/locator-plus/oo2t/locator-plus.html?hl=fr&gl=FR"
            width="100%" 
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            title="Localisation de nos sites Groupe Fabre Environnement"
            allow="geolocation; fullscreen; web-share"
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          />
        </div>
        
        <div className="text-center mt-8">
          <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
            <Link to="/sites" className="flex items-center">
              <MapPin className="mr-2 h-5 w-5" /> Voir tous nos sites
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
